import { getIntegrationDetails } from 'components/Previews/getIntegrationDetails'
import Styles from './XChrome.module.scss'
import { PlatformChromeProps } from './Types'
import { Avatar } from './Avatar'
import { Like, Repost, Views, Reply, Bookmark, Share } from 'components/Previews/XPreview/icons'

export const XChrome = ({ children, integration, caption }: PlatformChromeProps) => {
  const { picture, name, username } = getIntegrationDetails(integration)

  return (
    <div className={Styles.chrome}>
      <div className={Styles.left}>
        <Avatar picture={picture} className={Styles.avatar} />
      </div>
      <div className={Styles.right}>
        <div>
          <div className={Styles.header}>
            <span className={Styles.username}>{name}</span> <span>{username}</span> <span>•</span> <span>1d</span>
          </div>
          <div className={Styles.caption} dangerouslySetInnerHTML={{ __html: caption || '' }} />
        </div>
        <div className={Styles.content}>{children}</div>
        <div className={Styles.footer}>
          <Reply size={12} />
          <Repost size={12} />
          <Like size={12} />
          <Views size={12} />
          <Bookmark size={12} />
          <Share size={12} />
        </div>
      </div>
    </div>
  )
}
